<template>
  <div v-if="!getAppointmentDetails">
    <div class="flex flex-col laptop:grid grid-cols-1 laptop:grid-cols-3 gap-4 laptop:items-start">
      <div
        class="p-3 flex flex-col gap-3 laptop:gap-4 w-full rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
            <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
            <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">Details</h2>
          </div>
          <div class="mb-0 w-[50px] h-[50px] p-2 flex items-center justify-center rounded-full bg-[#EFEFEF]">
            <img v-if="apptDetail.show_logo" :src="apptDetail.depp_schedule.company_logo"
              class="w-full h-full object-contain">
          </div>
        </div>
        <div class="flex items-center justify-between shadow-[0px_0px_20px_0px_#00000026] p-2 rounded-[5px]">
          <h2 class="m-0 font-lato font-medium text-[14px] laptop:text-[20px] text-[#092E87]">
            Appointment Status:</h2>
          <div class="py-1 px-3 rounded-[5px] bg-opacity-10 bg-[#FE5000]">
            <p class="m-0 text-[14px] laptop:text-[16px] text-[#FE5000] capitalize">{{ apptDetail.status_text }}
            </p>
          </div>
        </div>
        <ul class="p-0 m-0 flex justify-between laptop:flex-col flex-wrap gap-2 laptop:gap-3 w-full">
          <li class="w-full flex justify-between items-center">
            <div>
              <label class="text-[14px] laptop:text-[16px] font-lato font-medium leading-[1.5] text-[#999999]">Appointment
                Title:</label>
              <p class="m-0 text-[14px] laptop:text-[16px] font-lato font-medium leading-[1] text-[#333333]">
                {{ apptDetail.title }}
              </p>
            </div>
            <div v-if="apptDetail.is_emergency == 1" class="h-[32px] w-[100px] rounded-[5px] flex items-center justify-center gap-2 font-roboto font-medium text-[12px] bg-[#FF6F6F] text-white">
              Emergency
              <img src="../../assets/images/emergency-white.png" alt="" class="w-[20px] h-[20px] object-contain">
            </div>
          </li>
          <li class="w-full">
            <label class="text-[14px] laptop:text-[16px] font-lato font-medium leading-[1.5] text-[#999999]">Appointment
              ID:</label>
            <p class="m-0 text-[14px] laptop:text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ apptDetail.id }}
            </p>
          </li>
          <li v-if="apptDetail.manual_quote.id > 0" class="w-full">
            <label class="text-[14px] laptop:text-[16px] font-lato font-medium leading-[1.5] text-[#999999]">Job
              ID:</label>
            <p class="m-0 text-[14px] laptop:text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ apptDetail.manual_quote.id }}
            </p>
          </li>
          <li class="w-full">
            <label class="text-[14px] laptop:text-[16px] font-lato font-medium leading-[1.5] text-[#999999]">Consumer
              Name:</label>
            <p class="m-0 text-[14px] laptop:text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ apptDetail.consumer.full_name }}
            </p>
          </li>
          <li class="w-[48%] laptop:w-full">
            <label class="text-[14px] laptop:text-[16px] font-lato font-medium leading-[1.5] text-[#999999]">Phone
              Number:</label>
            <p class="m-0 text-[14px] laptop:text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              <a class="underline m-0 text-[14px] laptop:text-[16px] font-lato font-medium leading-[1] text-[#333333]"
                :href="'tel:' + apptDetail.consumer.phone">
                {{ apptDetail.consumer.phone }}
              </a>
            </p>
          </li>
          <li class="w-[48%] laptop:w-full">
            <label class="text-[14px] laptop:text-[16px] font-lato font-medium leading-[1.5] text-[#999999]">Visit
              Schedule:</label>
            <p class="m-0 text-[14px] laptop:text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ convertTimsStampToDate(apptDetail.visit_date) }}
            </p>
          </li>
          <li class="w-[48%] laptop:w-full">
            <label class="text-[14px] laptop:text-[16px] font-lato font-medium leading-[1.5] text-[#999999]">Trade
              Type:</label>
            <p class="m-0 text-[14px] laptop:text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ apptDetail.trade_type }}
            </p>
          </li>
          <li class="w-[48%] laptop:w-full">
            <label
              class="text-[14px] laptop:text-[16px] font-lato font-medium leading-[1.5] text-[#999999]">Service:</label>
            <p class="m-0 text-[14px] laptop:text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ apptDetail.service_type_text }}
            </p>
          </li>
        </ul>
      </div>
      <div class="col-span-2 flex flex-col gap-4 w-full">
        <div
          class="mobile:p-1.5 laptop:p-3 flex items-center justify-between mobile:gap-2 laptop:gap-4 w-full mobile:rounded-full laptop:rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
          <div class="flex items-center mobile:gap-1.5 laptop:gap-3">
            <template v-for="(action, index) in actionButtons.slice(0, buttonShowCount)" :key="index">
              <button v-if="index % 2 == 0" type="button" @click="actionButtonClicked(action.title)"
                class="group flex items-center rounded-full gap-2 p-1.5 pl-3 font-lato font-normal text-[14px] h-[40px] mobile:text-[#fff] laptop:text-[#FE5000] hover:text-[#fff] border-1 border-[#FE5000] mobile:bg-[#FE5000] laptop:bg-[#fff] laptop:hover:bg-[#FE5000] transition duration-300">
                {{ action.title }}

                <span v-if="!$helper.isEmpty(getImageSrc(action.image))"
                  class="w-[26px] h-[26px] largeDesktop:h-[30px] largeDesktop:w-[30px] transition duration-300 flex justify-center items-center rounded-full laptop:group-hover:bg-white mobile:bg-white laptop:bg-[#FE5000] relative">
                  <!-- Default Image -->
                  <img :src="getImageSrc(action.image)" alt="icon"
                    class="w-[20px] h-[20px] largeDesktop:w-[22px] largeDesktop:h-[22px] transition mobile:hidden laptop:block laptop:group-hover:hidden" />

                  <!-- Hover Color Version -->
                  <div
                    class="w-[20px] h-[20px] largeDesktop:w-[22px] largeDesktop:h-[22px] absolute transition duration-300 mobile:block laptop:hidden laptop:group-hover:block"
                    :style="{
                      WebkitMask: `url(${getImageSrc(action.image)}) no-repeat center / contain`,
                      mask: `url(${getImageSrc(action.image)}) no-repeat center / contain`,
                      backgroundColor: '#FE5000'
                    }"></div>
                </span>
                <span v-else
                  class="w-[26px] h-[26px] largeDesktop:h-[30px] largeDesktop:w-[30px] transition duration-300 flex justify-center items-center rounded-full relative"></span>
              </button>
              <button v-else type="button" @click="actionButtonClicked(action.title)"
                class="group flex items-center rounded-full gap-2 p-1.5 pl-3 font-lato font-normal text-[14px] h-[40px] mobile:text-[#fff] laptop:text-[#092E87] laptop:hover:text-[#fff] border-1 border-[#092E87] mobile:bg-[#092E87] laptop:bg-[#fff] hover:bg-[#092E87] transition duration-300">
                {{ action.title }}
                <span v-if="!$helper.isEmpty(getImageSrc(action.image))"
                  class="w-[26px] h-[26px] largeDesktop:h-[30px] largeDesktop:w-[30px] transition duration-300 flex justify-center items-center rounded-full laptop:group-hover:bg-white mobile:bg-white laptop:bg-[#092E87] relative">
                  <!-- Default Image -->
                  <img :src="getImageSrc(action.image)" alt="icon"
                    class="w-[20px] h-[20px] largeDesktop:w-[22px] largeDesktop:h-[22px] transition mobile:hidden laptop:block laptop:group-hover:hidden" />

                  <!-- Hover Color Version -->
                  <div
                    class="w-[20px] h-[20px] largeDesktop:w-[22px] largeDesktop:h-[22px] absolute transition duration-300 mobile:block laptop:hidden laptop:group-hover:block"
                    :style="{
                      WebkitMask: `url(${getImageSrc(action.image)}) no-repeat center / contain`,
                      mask: `url(${getImageSrc(action.image)}) no-repeat center / contain`,
                      backgroundColor: '#092E87'
                    }"></div>
                </span>
                <span v-else
                  class="w-[26px] h-[26px] largeDesktop:h-[30px] largeDesktop:w-[30px] transition duration-300 flex justify-center items-center rounded-full relative"></span>


              </button>
            </template>
          </div>

          <div v-if="actionButtons.length > buttonShowCount" class="dropdown">
            <button class="w-[35px] h-[35px] rounded-full dropdown-toggle after:!hidden text-[#092E87] bg-[#EFEFEF]"
              type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
            </button>
            <ul class="dropdown-menu p-0">
              <template v-for="(action, index) in actionButtons.slice(buttonShowCount)" :key="'rest-' + index">
                <li><a class="dropdown-item cursor-pointer" @click="actionButtonClicked(action.title)">{{ action.title
                    }}</a></li>
              </template>
            </ul>
          </div>
          
        </div>
        <div class="p-3 rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
          <div class="googleApi rounded-[20px] overflow-hidden mt-0">
            <GMapMap :center="center" :zoom="16" map-type-id="terrain" style="width: 100%" class="h-[320px]" :options="{
              zoomControl: false,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
            }">
              <GMapMarker v-for="(m, index) in markers" :key="index" :position="m.position" :clickable="true"
                :draggable="true" @click="center = m.position" />
            </GMapMap>
          </div>
          <div class="laptop:flex justify-between items-center mt-3">
            <p class="text-[14px] text-center laptop:text-left m-0">{{ apptDetail.address }}</p>
            <div class="!w-max mobile:mx-auto mobile:mt-3 laptop:!m-0 laptop:!flex">
              <button @click="openGoogleMaps()" class="flex items-center gap-2 rounded-full px-3 py-1 bg-[#092E87]">
                <span class="inline-block text-[14px] font-lato text-[#fff]">Directions</span>
                <img src="../../assets/images/diraction-icon.png" alt="" class="w-[25px] h-[25px] object-contain">
              </button>
            </div>
          </div>
        </div>
        <div v-if="apptDetail.notes.length > 0" class="p-3 rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
          <div class="flex items-center gap-2 mb-3">
            <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
            <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
            <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">Notes</h2>
          </div>
          <div >
            <p class="m-0 p-2 h-[100px] rounded-[10px] bg-opacity-50 bg-[#EFEFEF]"
              v-html="getNotesTxt(apptDetail.notes)" />
          </div>
        </div>
      </div>
    </div>

    <div id="exampleModal" ref="tradecall" class="modal fade modal-lg" data-bs-backdrop="static"
      data-bs-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <TradeCallDialog @event="TradeCallBack" />
      </div>
    </div>

    <div id="serviceType" ref="serviceTypeModal" class="modal fade modal-lg" data-bs-backdrop="static"
      data-bs-keyboard="false" tabindex="-1" aria-labelledby="serviceTypeLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <ServiceTypeDialog @event="serviceTypeCallBack" :services="services" />
      </div>
    </div>

    <div v-if="isNotesOpen" id="notesModal" class="modal fade modal-md show bg-opacity-50 bg-[#000]" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog" style="display: block">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content !rounded-[20px]">
          <div class="modal-body p-4 pb-5">
            <div class="flex flex-col gap-4 w-full">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                  <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
                  <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
                  <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">Internal Notes</h2>
                </div>
                <button class="w-[40px] h-[40px] p-2 rounded-full bg-opacity-60 bg-[#EFEFEF]" @click="closeModal"
                  type="button" data-bs-dismiss="modal" aria-label="Close">
                  <img src="@/assets/images/modal-cross-icon.png">
                </button>
              </div>
              <noteBox />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TradeCallDialog from "@/components/tradecall_dialog/TradeCallDialog.vue";
// import ServiceTypeDialogue from "@/components/ServiceTypeDialogue.vue";
import ServiceTypeDialog from "./ServiceTypeDialog.vue";
import { Modal } from "bootstrap";
import moment from "moment";
import { useToast } from "vue-toastification";
import noteBox from "../notes/apptNoteModal.vue";
const toast = useToast();
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";

export default {
  components: {
    TradeCallDialog,
    noteBox,
    // ServiceTypeDialogue,
    ServiceTypeDialog
  },

  data() {
    return {
      isStartQuote: false,
      originlat: 0,
      originlng: 0,
      actionButtons: [],
      center: {
        lat: 0,
        lng: 0,
      },
      markers: [
        {
          position: {
            lat: 0,
            lng: 0,
          },
        }, // Along list of clusters
      ],
      isNotesOpen: false,
      serviceId: null
    };
  },
  computed: {
    ...mapGetters([
      "cancelAppointment",
      "getAppointmentDetails",
      "apptDetail",
      "setAppointmentAction",
      "saveApptointmentActionEnroute",
      "saveApptointmentActionArrived",
      "saveApptointmentCreatelObject",
      "services",
      "bookingConverted",
    ]),

    buttonShowCount() {
      return window.innerWidth <= 768 ? 2 : 3
    }
  },

  watch: {
    bookingConverted: function () {
      this.getAppointmenttDetails();
    },

    services: function () {
      disableScroll()
      this.modal = new Modal(this.$refs.serviceTypeModal);
      this.modal.show();
    },

    apptDetail: function () {
      let user = JSON.parse(localStorage.getItem('user'));
      let user_id = user.user.user_id;

      if (this.apptDetail.technician.user_id != user_id) {

        this.$router.push({
          name: 'NotFound',
        });

      } else {
        this.markers[0].position.lat = this.apptDetail.lat;
        this.markers[0].position.lng = this.apptDetail.lng;

        this.center.lat = this.apptDetail.lat;
        this.center.lng = this.apptDetail.lng;

        this.actionButtons = [];
        if (this.apptDetail.status == 0) {
          this.actionButtons.push({title:'On My Way', image:'on-my-way.png'});
          this.actionButtons.push({title:'Internal Notes', image:'internal-notes.png'});
        } else if (this.apptDetail.status == 1) {
          this.actionButtons.push({title:'Mark As Arrived', image:'mark-as-arrived.png'});
          this.actionButtons.push({title:'Internal Notes', image:'internal-notes.png'});
        } else if (this.apptDetail.status == 2) {
          this.actionButtons.push({title:'Start Quote', image:'start-quote.png'});
          this.actionButtons.push({title:'Internal Notes', image:'internal-notes.png'});
        } else if (this.apptDetail.status == 7) {
          //cancel status
        } else {
          if (this.apptDetail.flow_type == "sar") {
            if (this.apptDetail.booking.status + "" == "4") {
              this.serviceUpdateCall(this.apptDetail.booking.id, "sar")
              this.$router.push({
                path: `/select/unit/${this.apptDetail.booking.id}`,
                query: {
                  is_from_mobile:
                    Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0,
                },
              });
            } else {
              this.$router.push({
                path: `/job/detail/${this.apptDetail.booking.id}`,
                query: {
                  is_from_mobile:
                    Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0,
                },
              });
            }
          } else {
            if (this.isStartQuote) {
              this.serviceUpdateCall(this.apptDetail.manual_quote.id, "iq")
              this.$router.push({
                path: `/quote/detail/${this.apptDetail.manual_quote.id}`,
                query: {
                  is_edit: 1,
                },
              });
            } else {
              this.$router.push({
                path: `/quote/detail/${this.apptDetail.manual_quote.id}`,
              });
            }
          }
        }
      }
    },

    saveApptointmentActionEnroute: function () {
      toast.success("Appointment has been updated successfully.");
      this.getAppointmenttDetails();
    },

    saveApptointmentActionArrived: function () {
      toast.success("Appointment has been updated successfully.");
      this.getAppointmenttDetails();
    },

    saveApptointmentCreatelObject: function () {
      this.getAppointmenttDetails();
    },
    cancelAppointment: function () {
      toast.success("Appointment has been updated successfully.");
      this.getAppointmenttDetails();
    },
  },

  mounted() {
    this.getAppointmenttDetails();
  },

  methods: {
    ...mapActions([
      "appointmentCancel",
      "getAppointmentDetailsAPICall",
      "markAsEnrouteAPICall",
      "markAsArrivedAPICall",
      "appointmentCreate",
      "setCommponent",
      "getServices",
      "convretToBooking",
      "apptServiceUpdate"
    ]),


    getNotesTxt(note) {

      return note.replace("\n", "<br>")
    },
    getAppointmenttDetails() {
      this.getAppointmentDetailsAPICall({
        id: this.$route.params.id,
      });
    },

    markAsEnroute() {
      this.$dialog.show({
        title: "Status Change",
        text: "Are you sure you want to mark yourself enroute?",
        // image: "pop-req-img.png",
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.markAsEnrouteAPICall({
            appointment_id: this.$route.params.id,
          });
        },
      });
    },

    markAsArrived() {
      this.$dialog.show({
        title: "Status Change",
        text: "Are you sure you want to mark yourself as Arrived?",
        // image: "pop-req-img.png",
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.markAsArrivedAPICall({
            appointment_id: this.$route.params.id,
          });
        },
      });
    },

    TradeCallBack(data, waiveTradeCall) {
      enableScroll()
      if (data == "close") {
        this.modal.hide();
      } else if (data == "confirm") {
        this.modal.hide();
        this.isStartQuote = true;
        let params = {
          appointment_id: this.$route.params.id,
        }

        if (waiveTradeCall == 1) {
          params['waive_trade_call_fee'] = 1
        }
        else {
          params['waive_trade_call_fee'] = 0
        }

        this.appointmentCreate(params);
      }
    },

    startQuote() {
      this.isStartQuote = true;
      this.appointmentCreate({
        appointment_id: this.$route.params.id,
      });
    },

    convertTimsStampToDate(val) {
      return moment.unix(val).format("MM/DD/YYYY - hh:mm A");
    },

    convertNotesTimsStampToDate(val) {
      return moment.unix(val).format("hh:mm a MM/DD/YYYY");
    },

    actionButtonClicked(action) {
      if (action == "On My Way") {
        this.markAsEnroute();
      } else if (action == "Internal Notes") {
        this.openNotesModal();
      } else if (action == "Mark As Arrived") {
        this.markAsArrived();
      } else if (action == "Start Quote") {
        if (this.apptDetail.flow_type == "uq" && this.apptDetail.depp_schedule.is_tradecall_fee_applicable == 1) {
          disableScroll()
          this.modal = new Modal(this.$refs.tradecall);
          this.modal.show();
        } else {
          if (this.apptDetail.depp_schedule.can_service_type_update == '1') {
            this.getServices();
          } else {
            this.startQuoteCall()
          }
        }
      }
    },

    openNotesModal() {
      disableScroll()
      this.isNotesOpen = true;
    },
    closeModal() {
      enableScroll()
      this.isNotesOpen = false;
    },

    startQuoteCall() {
      this.$dialog.show({
        title: "Status Change",
        text: "Are you sure you want to start this quote?",
        onConfirm: () => {
          if (this.apptDetail.flow_type == "sar") {
            this.convertToBooking();
          } else {
            this.startQuote();
          }
        },
      });
    },

    convertToBooking() {
      this.convretToBooking({
        appointment_id: this.$route.params.id,
        service_id: this.apptDetail.service_id,
      });
    },

    serviceTypeCallBack(data, check) {
      this.serviceId = check
      enableScroll()
      if (data == "close") {
        this.modal.hide();
      } else if (data == "confirm") {
        this.modal.hide();
        this.startQuoteCall()
      }
    },

    openGoogleMaps() {
      const desLat = this.apptDetail.lat ?? 0;
      const desLng = this.apptDetail.lng ?? 0;
      const googleMapsUrl = `https://maps.google.com/?q=${desLat},${desLng}`;

      // Check if the Google Maps app is installed
      if (navigator.platform.indexOf("Win") > -1) {
        // Windows platform, open in a new window
        window.open(googleMapsUrl, "_blank");
      } else {
        // Non-Windows platform, try to open in the maps app
        window.location.href = googleMapsUrl;
        //  window.location.href =`geo:0,0?q=${encodeURIComponent(destination)}`;
      }
    },

    serviceUpdateCall(quote_id, quote_type) {
      if (this.apptDetail.depp_schedule.can_service_type_update == '1') {
        this.apptServiceUpdate({
          "quote_id": quote_id,
          "quote_type": quote_type,
          "service_id": this.serviceId
        })
      }
    },

    getImageSrc(imageName) {
      try {
        return require(`@/assets/images/buttons-icons/${imageName}`);
      } catch (error) {
        return ''; // ya default image
      }
    }
  },
};
</script>
